module.exports = __webpack_public_path__ + "img/target_icon03.9c0cff73.png";